import React from 'react'
// components
import { Button, BUTTON_LAYOUTS } from 'components/UI'
// views
import { CodesContainer, CodesGrid, CodesButtonRow } from '../views'

interface Props {
  codes: string[]
}

const BackupCodesDisplay: React.FC<Props> = ({ codes }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(codes.join('\n'))
  }

  const handleDownload = () => {
    const blob = new Blob([codes.join('\n')], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')

    a.href = url
    a.download = 'skefto-2fa-backup-codes.txt'
    a.click()
    URL.revokeObjectURL(url)
  }

  return (
    <CodesContainer>
      <CodesGrid>
        {codes.map((code, idx) => (
          <div key={idx}>{code}</div>
        ))}
      </CodesGrid>

      <CodesButtonRow>
        <Button layout={BUTTON_LAYOUTS.WHITE} onClick={handleCopy}>
          Copy to Clipboard
        </Button>

        <Button layout={BUTTON_LAYOUTS.WHITE} onClick={handleDownload}>
          Download as Text File
        </Button>
      </CodesButtonRow>
    </CodesContainer>
  )
}

export default BackupCodesDisplay
